import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { maxAppWidth, StyledParagraph, theme } from '../../theme/Global'
import CompanyLogo from './companyLogo'

const FooterWrap = styled.div`
  max-width: ${maxAppWidth};
  margin: 1rem auto;
`
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`
const FooterText = styled(StyledParagraph)`
  color: ${theme.colors.whiteText};
  display: inline-block;  
  font-size: 13px;
  margin-left: 25px;
`
const FooterDisclaimer = styled(StyledParagraph)`
  color: ${theme.colors.whiteText};
  opacity: .8;
  font-size: 13px;
  width: 400px;
  margin-right: -20px;
`
const CopyrightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
`

const FooterRenderer = ({ authenticated, year }) => (
  <footer
    style={
      authenticated
        ? {}
        : { display: 'none' }
    }
  >
    <FooterWrap>
      <Container>
        <CopyrightContainer>
          <CompanyLogo size="large" />
          <FooterText>
            Copyright © {year} GovDocs, Inc. GovDocs is a registered
            trademark of GovDocs, Inc.
          </FooterText>
        </CopyrightContainer>
        <FooterDisclaimer data-testid="disclaimer-text">
            DISCLAIMER: The information in this application is provided
            for informational purposes only and does not constitute legal
            advice.
        </FooterDisclaimer>
      </Container>
    </FooterWrap>
  </footer>
)

FooterRenderer.propTypes = {
  authenticated: PropTypes.bool,
  year: PropTypes.number.isRequired
}

FooterRenderer.defaultProps = { authenticated: false }

export const mapStateToProps = (state) => ({
  authenticated: state.account.authenticated,
  year: new Date().getFullYear()
})

export default connect(mapStateToProps)(FooterRenderer)
